import { Page } from '@models/page';
import { PagedResult } from '@models/pagination';
import { httpGet, httpPost } from './apiService';
import { SlugEntityAdminApiService } from './slugEntityAdminApiService';

export class PageAdminService extends SlugEntityAdminApiService<Page> {
    public constructor() {
        super('/api/admin/page');
    }

    public async getRedirectPageList(
        pageNumber: number,
        rowsPerPage: number,
        languageId: number
    ): Promise<PagedResult<Page> | undefined> {
        const response = await httpGet(`${this.baseUrl}/redirects/${languageId}/${pageNumber + 1}/${rowsPerPage}`);

        return this.returnResult(await response.json());
    }

    public async getSearchedRedirectPageList(
        pageNumber: number,
        rowsPerPage: number,
        languageId: number,
        searchTerm: string
    ): Promise<PagedResult<Page> | undefined> {
        const response = await httpGet(
            `${this.baseUrl}/search/redirects/${languageId}/${pageNumber + 1}/${rowsPerPage}/${searchTerm}`
        );

        return this.returnResult<PagedResult<Page>>(await response.json());
    }

    public async createDuplicatePage(page: Page, id: number): Promise<Page | undefined> {
        const response = await httpPost(`${this.baseUrl}/duplicate/${id}`, JSON.stringify(page));

        return this.returnResult<Page>(await response.json());
    }

    public async getPagesBySearchTerm(languageId: number, searchTerm: string): Promise<Page[] | undefined> {
        const response = await httpGet(
            `${this.baseUrl}/search/${languageId}/?searchQuery=${encodeURIComponent(searchTerm)}`
        );

        return this.returnResult<Page[]>(await response.json());
    }
}
